import { JsonObject, JsonProperty } from 'json2typescript';
import TrialSubQuestion from '@/models/entry/TrialSubQuestion';
import QuestionResources from '@/models/entry/QuestionResources';

/**
 * 体験版 問題クラス
 */
@JsonObject('TrialQuestion')
export default class TrialQuestion {
  constructor() {
    this.questionCode = '';
    this.questionTitle = '';
    this.questionStatement = '';
    this.answerType = '';
    this.isFixed = false;
    this.subQuestions = [];
    this.questionResources = [];
    this.questionNumber = 0;
    this.isBookMark = false;
  }

  @JsonProperty('question_code')
  public questionCode: string;

  @JsonProperty('question_title')
  public questionTitle: string;

  @JsonProperty('question_statement')
  public questionStatement: string;

  @JsonProperty('answer_type')
  public answerType: string;

  @JsonProperty('is_fixed')
  public isFixed: boolean;

  @JsonProperty('sub_questions', [TrialSubQuestion], true)
  public subQuestions: TrialSubQuestion[];

  @JsonProperty('question_resources', [QuestionResources], true)
  public questionResources: QuestionResources[];

  /**
   * 問題番号
   */
  public questionNumber: number;

  /**
   * ブックマークフラグ
   */
  public isBookMark: boolean;

  isAnswer() {
    // 設問すべての解答データ有無をチェックし1個でもない場合未回答とする
    for (let i = 0; i < this.subQuestions.length; i += 1) {
      if (!this.subQuestions[i].isAnswer()) {
        return false;
      }
    }
    return true;
  }
}
